<template>
<fade-transition>
<div>
    <template v-if="mode == 'view'">
        <div class="c-resource-view__container t-background-white-grey">
            <div class="t-margin-left-s t-margin-right-s">
                <div class="o-grid">
                    <div class="o-grid__column" data-size="sm:12 md:3 lg:3">
                        <div class="c-resource__description">
                            <span class="c-resource__label">Namn</span>
                            <p class="c-resource__content">{{description}}</p>
                        </div>
                    </div>
                    <div class="o-grid__column" data-size="sm:12 md:3 lg:3">
                        <div class="c-resource__description">
                            <span class="c-resource__label">Ansvarig</span>
                            <p class="c-resource__content">{{responsible}}</p>
                        </div>
                    </div>
                    <div class="o-grid__column" data-size="sm:12 md:2 lg:2">
                        <div class="c-resource__description">
                            <span class="c-resource__label">Arkiv</span>
                            <p class="c-resource__content">{{archive}}</p>
                        </div>
                    </div>
                    <div class="o-grid__column" data-size="sm:12 md:2 lg:2">
                        <div class="c-resource__description">
                            <span class="c-resource__label">Arkiveringstid</span>
                            <p class="c-resource__content">{{archivePeriod}}</p>
                        </div>
                    </div>
					<can i="manage" :a="processType">
                                                <div class="o-grid__column" data-size="sm:12 md:1 lg:1">
                        <form class="c-form" @submit.prevent="handleSubmit">
                            <button v-if="sortIndex !== sortIndexes[0]" class="c-button c-button--linkstyle c-button--reset c-process-step__move-up c-resource__move-up" title="Flytta upp" type="submit" @click="setSubmitType('moveUp')">
                                <vue-icon name="expand" size="c-icon--17px"></vue-icon>
                            </button>
                            <br/>
                            <button v-if="sortIndex !== sortIndexes[sortIndexes.length-1]" class="c-button c-button--linkstyle c-button--reset" title="Flytta ner" type="submit" @click="setSubmitType('moveDown')">
                                <vue-icon name="expand" size="c-icon--17px"></vue-icon>
                            </button>
                        </form>
                    </div>
						<div class="o-grid__column" data-size="sm:12 md:1 lg:1">
							<button type="button" class="c-button c-button--linkstyle c-button--reset c-resource-view__button c-resource-view__aligned-button" @click="goToEditMode">
								<vue-icon name="edit" size="c-icon--17px"></vue-icon>
							</button>
						</div>
					</can>
                </div>
            </div>
            <resource-links-data-provider 
				:processId="processId" 
				:processStepId="processStepId" 
				:resourceId="resourceId">
					<resource-links 
						slot-scope="dataProvider" 
						:resource-links="dataProvider.resourceLinks"
						:resourceId="resourceId"
						:show-create="dataProvider.showCreate"
						:process-type="processType"
						@setShowCreate="dataProvider.setShowCreate"
						@createResourceLink="dataProvider.createResourceLink"
						@deleteResourceLink="dataProvider.deleteResourceLink" 
						@editResourceLink="dataProvider.editResourceLink"
                        @sortResourceLinks="dataProvider.sortResourceLinks">
					</resource-links>
            </resource-links-data-provider>
        </div>
    </template>
    <template v-if="mode == 'create' || mode == 'edit'">
        <div class="c-resource__container c-buffer-box c-buffer-box--border-all t-margin-top-s t-margin-bottom-s" v-bind:class="{'t-background-white-grey t-border-green': mode == 'create' || mode == 'edit'}">
            <div class="t-margin-left-s t-margin-right-s">
                <form class="c-form" @submit.prevent="handleSubmit">
                    <fieldset>
                        <div class="o-grid">
                            <div class="o-grid__column" data-size="sm:12 md:3 lg:3">
                                <div class="c-form__item">
									<vue-input label="Namn" input-id="description" :value="description" ref="resourceDescription"></vue-input>
                                </div>
                            </div>
                            <div class="o-grid__column" data-size="sm:12 md:3 lg:3">
                                <div class="c-form__item">
									<vue-input label="Ansvarig" input-id="responsible" :value="responsible" :maxlength="50" ref="resourceResponsible"></vue-input>
                                </div>
                            </div>
                            <div class="o-grid__column" data-size="sm:12 md:3 lg:3">
                                <div class="c-form__item">
									<vue-input label="Arkiv" input-id="archive" :value="archive" :maxlength="50" ref="resourceArchive"></vue-input>
                                </div>
                            </div>
                            <div class="o-grid__column" data-size="sm:12 md:3 lg:3">
                                <div class="c-form__item">
									<vue-input label="Arkiveringstid" input-id="archivePeriod" :value="archivePeriod" :maxlength="50" ref="resourceArchivePeriod"></vue-input>
                                </div>
                            </div>
                        </div>
                        <div>
                            <resource-links-data-provider v-if="id !== '0' && mode==='view'" :processId="processId" :processStepId="processStepId" :resourceId="resourceId">
                                <resource-links 
									slot-scope="dataProvider" 
									:process-type="processType"
									:resource-links="dataProvider.resourceLinks"
									:parent-mode="mode"
									:resource-id="resourceId"
									:show-create="dataProvider.showCreate"
									@setShowCreate="dataProvider.setShowCreate"
									@createResourceLink="dataProvider.createResourceLink"
									@deleteResourceLink="dataProvider.deleteResourceLink" 
									@editResourceLink="dataProvider.editResourceLink"
                                    @sortResourceLinks="dataProvider.sortResourceLinks"
									>
								</resource-links>
                            </resource-links-data-provider>
                        </div>
						<template v-if="mode === 'create'">
							<button class="c-button c-button--primary t-margin-top-s" type="submit" @click="setSubmitType('create')">Spara</button>
							<button class="c-button c-button--linkstyle c-button--reset" type="button" @click="cancelCreateResource">Avbryt</button>
						</template>
                        <template v-if="mode === 'edit'">
							<div class="t-space-between">
								<div class="t-margin-bottom-xs">
									<button class="c-button c-button--primary" type="submit" @click="setSubmitType('edit')">Spara</button>
									<button class="c-button c-button--linkstyle c-button--reset" type="button" @click="cancelEditResource">Avbryt</button>
								</div>
								<button type="submit" class="c-button c-button--linkstyle c-button--linkstyle__secondary c-button--reset t-margin-bottom-xs" @click="toggleDeleteResourceModal">
									<vue-icon name="delete" size="c-icon--17px"></vue-icon>
										<span class="c-button__title">Ta bort dokumentation</span>
								</button>
							</div>
							<modal :show="showDeleteResourceModal" @closeModal="toggleDeleteResourceModal">
								<div class="c-modal__content t-background-white t-text-align-center">
									<h1 class="t-text-style-alpha">Du tar nu bort dokumentationen med beskrivningen "{{this.description}}"</h1>
									<form @submit.prevent="handleSubmit" class="c-form">
										<button class="c-button c-button--linkstyle c-button--reset t-margin-top-m" @click="toggleDeleteResourceModal">
											<span>Avbryt</span>
										</button>
										<button class="c-button c-button--primary" type="submit" @click="setSubmitType('delete')">Ta bort</button>
									</form>
								</div>
							</modal>
						</template>
                    </fieldset>
                </form>
            </div>
        </div>
    </template>
</div>
</fade-transition>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import VueIcon from '@/components/vue-components/vue-icon/VueIcon.vue';
import VueInput from '@/components/vue-components/vue-input/VueInput.vue';
import ResourceLinksDataProvider from '@/components/INQ/resource-links-data-provider/ResourceLinksDataProvider.vue';
import ResourceLinks from '@/components/INQ/resource-links/ResourceLinks.vue';
import Modal from '@/components/vue-components/modal/Modal.vue';
import { FadeTransition } from 'vue2-transitions';
export default {
    name: 'ResourceItem',
    props: {
        processId: {
            type: String,
            default: '0'
        },
		processType: {
			type: String,
			default: ''
		},
        processStepId: {
            type: String,
            default: '0'
        },
        resourceId: {
            type: String,
            default: ''
        },
        mode: {
            type: String,
            default: 'view'
        },
        id: {
            type: String,
            default: '0'
        },
        description: {
            type: String,
            default: ''
        },
        responsible: {
            type: String,
            default: ''
        },
        archive: {
            type: String,
            default: ''
        },
        archivePeriod: {
            type: String,
            default: ''
		},
        sortIndex: {
            type: Number,
            default: 1
        },
        sortIndexes: {
			type: Array,
			default: []
		}
    },
    components: {
        ResourceLinksDataProvider,
		ResourceLinks,
		VueInput,
		VueIcon,
		Modal,
		FadeTransition
    },
    data() {
        return {
            id: '',
			submitType: '',
			showDeleteResourceModal: false
        };
    },
    computed: {
        resource() {
            if (this.id !== '0') {
                return this.$store.getters['processes/resource'](this.id);
            } else {
                return {};
            }
        }
    },
    methods: {
		setSubmitType(type) {
            this.submitType = type;
        },
        goToEditMode() {
            this.mode = 'edit';
        },
        goToViewMode() {
            this.mode = 'view';
        },
		cancelResource() {
			this.$emit('cancelResource');
		},
		createResource() {
			let description = this.$refs.resourceDescription.getValue();
			let responsible = this.$refs.resourceResponsible.getValue();
			let archive = this.$refs.resourceArchive.getValue();
			let archivePeriod = this.$refs.resourceArchivePeriod.getValue();
			this.$emit('createResource', {
				processStepId: this.processStepId, 
				description: description, 
				responsible: responsible, 
				archive: archive, 
				archivePeriod: archivePeriod
			});
		},
		deleteResource() {
			this.$emit('deleteResource', this.resourceId);
			this.goToViewMode();
		},
        sortResourceLinks({ id, sortIndex }){
			this.$emit('sortResourceLinks', {
				id: id,
				sortIndex: sortIndex,
			});
        },
        moveUp() {
			this.$emit('sortResources', {
				id: this.id,
				sortIndex: this.sortIndex - 1,
			});
		},
		moveDown() {
			this.$emit('sortResources', {
				id: this.id,
				sortIndex: this.sortIndex + 1,
			});
		},
		editResource() {
			let description = this.$refs.resourceDescription.getValue();
			let responsible = this.$refs.resourceResponsible.getValue();
			let archive = this.$refs.resourceArchive.getValue();
			let archivePeriod = this.$refs.resourceArchivePeriod.getValue();
			this.$emit('editResource', {
				resourceId: this.resourceId,
				description: description, 
				responsible: responsible, 
				archive: archive, 
				archivePeriod: archivePeriod});
			this.goToViewMode();
		},
		cancelEditResource() {
			this.goToViewMode();
		},
		cancelCreateResource() {
			this.$emit('toggleShowCreate');
		},
		handleSubmit() {
            switch (this.submitType) {
                case 'create':
                    this.createResource();
                    break;
                case 'edit':
                    this.editResource();
                    break;
                case 'delete':
                    this.deleteResource();
                    break;
                case 'moveUp':
					this.moveUp();
					break;
				case 'moveDown':
					this.moveDown();
					break;
            }
		},
		toggleDeleteResourceModal() {
			this.showDeleteResourceModal = !this.showDeleteResourceModal;
		}
    },
    created() {
        if (this.$props.resourceId) {
            this.id = this.$props.resourceId;
        }
    }
};
</script>
